import { createReducer, on } from '@ngrx/store';
import { IEmpleador } from '@shared/interfaces/app.state.interfaces';
import { empleador, updateEmpleador } from '../actions/empleador.actions';

export const initialState: IEmpleador = {} as IEmpleador;

export const empleadorReducer = createReducer(
    initialState,
    on(empleador, ((state, { item }) => {
        return { ...state, ...item }
    })),
    on(updateEmpleador, (state, { changes }): IEmpleador => ({
        ...state,
        ...changes
    }))
)